var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "b837261c26783f027f21b44898290a03117823d3"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["gatsby@deltamath-2d0d222f8"] = {
  id: "b837261c26783f027f21b44898290a03117823d3"
};